<template>
  <!-- 取消了emptyCard -->
  <div
    :class="{
      'layout-width': [
        'grid',
        'table',
        'selectInputList',
        'tabs',
        'card',
        'selectCard',
        'editor',
        'batch',
        'divider',
        'html'
      ].includes(record.type)
    }"
  >
    <!-- 动态表格设计模块 start -->
    <template v-if="record.type === 'batch'">
      <div
        class="batch-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-form-item
          :label="!record.options.showLabel ? '' : record.label"
          :label-col="
            config.layout === 'horizontal' && record.options.showLabel
              ? config.labelLayout === 'flex'
                ? { style: `width:${config.labelWidth}px` }
                : config.labelCol
              : {}
          "
          :wrapper-col="
            config.layout === 'horizontal' && record.options.showLabel
              ? config.labelLayout === 'flex'
                ? { style: 'width:auto;flex:1' }
                : config.wrapperCol
              : {}
          "
          :style="
            config.layout === 'horizontal' &&
            config.labelLayout === 'flex' &&
            record.options.showLabel
              ? { display: 'flex' }
              : {}
          "
        >
          <draggable
            tag="div"
            class="draggable-box"
            v-bind="{
              group: insertAllowed ? 'form-draggable' : '',
              ghostClass: 'moving',
              animation: 180,
              handle: '.drag-move'
            }"
            v-model="record.list"
            @start="$emit('dragStart', $event, record.list)"
            @add="$emit('handleColAdd', $event, record.list)"
          >
            <transition-group tag="div" name="list" class="list-main">
              <formNode
                v-for="item in record.list"
                :key="item.key"
                class="drag-move"
                :selectItem.sync="selectItem"
                :record="item"
                :hideModel="hideModel"
                :hideTypeModel="hideTypeModel"
                :config="config"
                @handleSelectItem="handleSelectItem"
                @handleColAdd="handleColAdd"
                @handleCopy="$emit('handleCopy')"
                @handleShowRightMenu="handleShowRightMenu"
                @handleDelete="$emit('handleDelete')"
                @handleRelation="handleRelation"
              />
            </transition-group>
          </draggable>
        </a-form-item>
        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 动态表格设计模块 end -->
    <!-- 选择输入列 start -->
    <template v-else-if="record.type === 'selectInputList'">
      <div
        class="select-input-list-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-form-item
          :label="!record.options.showLabel ? '' : record.label"
          :label-col="
            config.layout === 'horizontal' && record.options.showLabel
              ? config.labelLayout === 'flex'
                ? { style: `width:${config.labelWidth}px` }
                : config.labelCol
              : {}
          "
          :wrapper-col="
            config.layout === 'horizontal' && record.options.showLabel
              ? config.labelLayout === 'flex'
                ? { style: 'width:auto;flex:1' }
                : config.wrapperCol
              : {}
          "
          :style="
            config.layout === 'horizontal' &&
            config.labelLayout === 'flex' &&
            record.options.showLabel
              ? { display: 'flex' }
              : {}
          "
        >
          <div
            class="column-box"
            v-for="(column, index) in record.columns"
            :key="index"
          >
            <div class="check-box">
              <CheckboxItem v-if="record.options.multiple" disabled>
                {{ column.label }}
              </CheckboxItem>
              <RadioItem v-else disabled name="radio" :value="column.value">{{
                column.label
              }}</RadioItem>
            </div>
            <draggable
              tag="div"
              class="draggable-box"
              v-bind="{
                group: insertAllowed ? 'form-draggable' : '',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="column.list"
              @start="$emit('dragStart', $event, column.list)"
              @add="$emit('handleColAdd', $event, column.list)"
            >
              <transition-group tag="div" name="list" class="list-main">
                <formNode
                  v-for="item in column.list"
                  :key="item.key"
                  class="drag-move"
                  :selectItem.sync="selectItem"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                  @handleRelation="handleRelation"
                />
              </transition-group>
            </draggable>
          </div>
        </a-form-item>
        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 选择输入列 end -->
    <!-- 标签Tabs布局 start -->
    <template v-else-if="record.type === 'tabs'">
      <div
        class="grid-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-tabs
          class="grid-row"
          :default-active-key="0"
          :tabBarGutter="record.options.tabBarGutter || null"
          :type="record.options.type"
          :size="record.options.size"
          :tabPosition="record.options.tabPosition"
          :animated="record.options.animated"
        >
          <a-tab-pane
            v-for="(tabItem, index) in record.columns"
            :key="index"
            :tab="tabItem.label"
          >
            <div class="grid-col">
              <draggable
                tag="div"
                class="draggable-box"
                v-bind="{
                  group: 'form-draggable',
                  ghostClass: 'moving',
                  animation: 180,
                  handle: '.drag-move'
                }"
                v-model="tabItem.list"
                @start="$emit('dragStart', $event, tabItem.list)"
                @add="$emit('handleColAdd', $event, tabItem.list)"
              >
                <transition-group tag="div" name="list" class="list-main">
                  <layoutItem
                    class="drag-move"
                    v-for="item in tabItem.list"
                    :key="item.key"
                    :selectItem.sync="selectItem"
                    :startType="startType"
                    :insertAllowedType="insertAllowedType"
                    :record="item"
                    :hideModel="hideModel"
                    :hideTypeModel="hideTypeModel"
                    :config="config"
                    @handleSelectItem="handleSelectItem"
                    @handleColAdd="handleColAdd"
                    @handleCopy="$emit('handleCopy')"
                    @handleShowRightMenu="handleShowRightMenu"
                    @handleDelete="$emit('handleDelete')"
                    @change="handleChange"
                  />
                </transition-group>
              </draggable>
            </div>
          </a-tab-pane>
        </a-tabs>

        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 标签Tabs布局 end -->
    <!-- 栅格布局 start -->
    <template v-else-if="record.type === 'grid'">
      <div
        class="grid-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-row class="grid-row" :gutter="record.options.gutter">
          <a-col
            class="grid-col"
            v-for="(colItem, idnex) in record.columns"
            :key="idnex"
            :span="colItem.span || 0"
          >
            <draggable
              tag="div"
              class="draggable-box"
              v-bind="{
                group: 'form-draggable',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="colItem.list"
              @start="$emit('dragStart', $event, colItem.list)"
              @add="$emit('handleColAdd', $event, colItem.list)"
            >
              <transition-group tag="div" name="list" class="list-main">
                <layoutItem
                  class="drag-move"
                  v-for="item in colItem.list"
                  :key="item.key"
                  :selectItem.sync="selectItem"
                  :startType="startType"
                  :insertAllowedType="insertAllowedType"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                />
              </transition-group>
            </draggable>
          </a-col>
        </a-row>

        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 栅格布局 end -->
    <!-- 卡片布局 start -->
    <template v-else-if="record.type === 'card'">
      <div
        class="grid-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-card class="grid-row" :title="record.label">
          <div class="grid-col">
            <draggable
              tag="div"
              class="draggable-box"
              v-bind="{
                group: 'form-draggable',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="record.list"
              @start="$emit('dragStart', $event, record.list)"
              @add="$emit('handleColAdd', $event, record.list)"
            >
              <transition-group tag="div" name="list" class="list-main">
                <layoutItem
                  class="drag-move"
                  v-for="item in record.list"
                  :key="item.key"
                  :selectItem.sync="selectItem"
                  :startType="startType"
                  :insertAllowedType="insertAllowedType"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                />
              </transition-group>
            </draggable>
          </div>
        </a-card>

        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 卡片布局 end -->
    <!-- 带选择卡片布局 start -->
    <template v-else-if="record.type === 'selectCard'">
      <div
        class="grid-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-card class="grid-row">
          <span slot="title">
            <span v-if="editable" class="focusable-input" v-all-blur="handleAllBlurred">
              <a-input ref="labelInput" v-model="record.sequence" style="width: 10%; margin-right: 5px;" />
              <a-input v-model="record.label" style="width: 60%;" />
              <a @click.stop="editSave" style="margin: 0px 10px">保存</a>
              <a @click.stop="editCancel">取消</a>
            </span>
            <span v-else>
              <a-tooltip>
                <span v-text="record.sequence + ' ' + record.label" @dblclick="labelEdit"></span>
                <span v-if="record.help" slot="title" v-html="record.help"></span>
                <a-icon
                  v-if="record.help"
                  class="question-circle"
                  type="question-circle-o"
                />
              </a-tooltip>
            </span>
          </span>
          
          <!-- For select item -->
          <div class="form-item-box">
            <formNode
              :key="record.key"
              :selectItem.sync="selectItem"
              :record="record"
              :config="config"
              :hideModel="hideModel"
              :hideTypeModel="hideTypeModel"
              :enableCopy="false"
              :enableDelete="false"
              @handleSelectItem="handleSelectItem"
              @handleShowRightMenu="$emit('handleShowRightMenu')"
              @handleRelation="handleRelation"
            />
          </div>
          <div class="grid-col">
            <draggable
              tag="div"
              class="draggable-box"
              v-bind="{
                group: 'form-draggable',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="record.list"
              @start="$emit('dragStart', $event, record.list)"
              @add="$emit('handleColAdd', $event, record.list)"
            >
              <transition-group tag="div" name="list" class="list-main">
                <layoutItem
                  class="drag-move"
                  v-for="item in record.list"
                  :key="item.key"
                  :selectItem.sync="selectItem"
                  :startType="startType"
                  :insertAllowedType="insertAllowedType"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                />
              </transition-group>
            </draggable>
          </div>
        </a-card>

        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 带选择卡片布局 end -->
    <!-- 空的卡片布局 start -->
    <template v-else-if="record.type === 'emptyCard'">
      <div
        class="grid-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
        <a-card class="grid-row">
          <div class="grid-col empty-card-grid">
            <div :key="record.key + 'parent'" class="rightnote">
              父题
            </div>
            <draggable
              tag="div"
              class="draggable-box"
              :disabled="isDraDisabled"
              v-bind="{
                group: 'form-draggable',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="record.parent"
              @start="$emit('dragStart', $event, record.parent)"
              @add="handleColReplace($event, record.parent)"
            >
              <transition-group tag="div" name="parent" class="list-main">
                <layoutItem
                  class="drag-move"
                  v-for="item in record.parent"
                  :key="item.key"
                  :selectItem.sync="selectItem"
                  :startType="startType"
                  :insertAllowedType="insertAllowedType"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  :enableCopy="false"
                  :enableDelete="false"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                />
              </transition-group>
            </draggable>
          </div>
          <p></p>
          <div class="grid-col empty-card-grid">
            <div :key="record.key + 'child'" class="rightnote">
              子题
            </div>
            <draggable
              tag="div"
              class="draggable-box"
              :disabled="isDraDisabled"
              v-bind="{
                group: 'form-draggable',
                ghostClass: 'moving',
                animation: 180,
                handle: '.drag-move'
              }"
              v-model="record.list"
              @start="$emit('dragStart', $event, record.list)"
              @add="$emit('handleColAdd', $event, record.list)"
            >
              <transition-group tag="div" name="list" class="list-main">
                <layoutItem
                  class="drag-move"
                  v-for="item in record.list"
                  :key="item.key"
                  :selectItem.sync="selectItem"
                  :startType="startType"
                  :insertAllowedType="insertAllowedType"
                  :record="item"
                  :hideModel="hideModel"
                  :hideTypeModel="hideTypeModel"
                  :config="config"
                  @handleSelectItem="handleSelectItem"
                  @handleColAdd="handleColAdd"
                  @handleCopy="$emit('handleCopy')"
                  @handleShowRightMenu="handleShowRightMenu"
                  @handleDelete="$emit('handleDelete')"
                />
              </transition-group>
            </draggable>
          </div>
        </a-card>

        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 空的卡片布局 end -->
    <!-- 表格布局 start -->
    <template v-else-if="record.type === 'table'">
      <div
        class="table-box"
        :class="{ active: record.key === selectItem.key }"
        @click.stop="handleSelectItem(record)"
      >
      <a-card class="grid-row">
        <span slot="title">
            <span v-if="editable" class="focusable-input" v-all-blur="handleAllBlurred">
              <a-input ref="labelInput" v-model="record.sequence" style="width: 10%; margin-right: 5px;" />
              <a-input v-model="record.label" style="width: 60%;" />
              <a @click.stop="editSave" style="margin: 0px 10px">保存</a>
              <a @click.stop="editCancel">取消</a>
            </span>
            <span v-else>
              <a-tooltip>
                <span v-text="record.sequence + ' ' + record.label" @click="labelEdit"></span>
                <span v-if="record.help" slot="title" v-html="record.help"></span>
                <a-icon
                  v-if="record.help"
                  class="question-circle"
                  type="question-circle-o"
                />
              </a-tooltip>
            </span>
          </span>
      </a-card>
        <table
          class="table-layout kk-table-9136076486841527"
          :class="{
            bright: record.options.bright,
            small: record.options.small,
            bordered: record.options.bordered
          }"
          :style="
            'width:' + record.options.width + ';' + record.options.customStyle
          "
        >
          <tr v-for="(trItem, trIndex) in record.trs" :key="trIndex">
            <td
              class="table-td"
              v-for="(tdItem, tdIndex) in trItem.tds"
              v-show="tdItem.colspan && tdItem.rowspan"
              :key="tdIndex"
              :colspan="tdItem.colspan"
              :rowspan="tdItem.rowspan"
              @contextmenu.prevent="
                $emit('handleShowRightMenu', $event, record, trIndex, tdIndex)
              "
            >
              <draggable
                tag="div"
                class="draggable-box"
                v-bind="{
                  group: 'form-draggable',
                  ghostClass: 'moving',
                  animation: 180,
                  handle: '.drag-move'
                }"
                v-model="tdItem.list"
                @start="$emit('dragStart', $event, tdItem.list)"
                @add="$emit('handleColAdd', $event, tdItem.list)"
              >
                <transition-group
                  tag="div"
                  name="list"
                  :style="{ 'min-height': tdItem.rowspan * 40 - 10 + 'px' }"
                  class="list-main"
                >
                  <layoutItem
                    class="drag-move"
                    v-for="item in tdItem.list"
                    :key="item.key"
                    :selectItem.sync="selectItem"
                    :startType="startType"
                    :insertAllowedType="insertAllowedType"
                    :record="item"
                    :hideModel="hideModel"
                    :hideTypeModel="hideTypeModel"
                    :config="config"
                    :enableDelete="false"
                    @handleSelectItem="handleSelectItem"
                    @handleColAdd="handleColAdd"
                    @handleCopy="$emit('handleCopy')"
                    @handleShowRightMenu="handleShowRightMenu"
                    @handleDelete="$emit('handleDelete')"
                    @change="handleChange"
                  />
                </transition-group>
              </draggable>
            </td>
          </tr>
        </table>
        <div
          v-if="!record.isTableCell"
          class="relation"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="handleRelationItem"
        >
          <a-tooltip title="查看">
            <a-icon type="eye" :style="{ fontSize: '16px', color: '#323232' }"/>
          </a-tooltip>
        </div>
        <div
          class="copy"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleCopy')"
        >
          <a-tooltip title="复制">
            <a-icon type="copy" />
          </a-tooltip>
        </div>
        <div
          class="delete"
          :class="record.key === selectItem.key ? 'active' : 'unactivated'"
          @click.stop="$emit('handleDelete')"
        >
          <a-tooltip title="删除">
            <a-icon type="delete" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <!-- 表格布局 end -->
    <template v-else>
      <formNode
        :key="record.key"
        :selectItem.sync="selectItem"
        :record="record"
        :config="config"
        :hideModel="hideModel"
        :hideTypeModel="hideTypeModel"
        :enableCopy="enableCopy"
        :enableDelete="enableDelete"
        :selectForm="selectForm"
        @handleSelectItem="handleSelectItem"
        @handleCopy="$emit('handleCopy')"
        @handleDelete="$emit('handleDelete')"
        @handleShowRightMenu="$emit('handleShowRightMenu')"
        @handleRelation="handleRelation"
        @refreshOptions="refreshOptions"
      />
    </template>
  </div>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 * description 使用递归组件调用自己，生成布局结构及表单
 */
import draggable from "vuedraggable";
import formNode from "./formNode";
import { pluginManager } from "../../../utils/index";

const CheckboxItem = pluginManager.getComponent("checkboxItem").component;
const RadioItem = pluginManager.getComponent("radioItem").component;
export default {
  name: "layoutItem",
  props: {
    record: {
      type: Object,
      required: true
    },
    selectItem: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    startType: {
      type: String,
      required: true
    },
    insertAllowedType: {
      type: Array,
      required: true
    },
    hideModel: {
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      type: Boolean,
      default: false
    },
    enableCopy: {
      type: Boolean,
      default: true
    },
    enableDelete: {
      type: Boolean,
      default: true
    },
    selectForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editable: false,
      preSequence: "",
      preLabel: "",
    };
  },
  computed: {
    insertAllowed() {
      return this.insertAllowedType.includes(this.startType);
    },
    isDraDisabled() {
      return this.$store.getters.isDisable
    }
  },
  components: {
    formNode,
    draggable,
    CheckboxItem,
    RadioItem
  },
  methods: {
    handleShowRightMenu(e, record, trIndex, tdIndex) {
      this.$emit("handleShowRightMenu", e, record, trIndex, tdIndex);
    },
    handleSelectItem(record) {
      console.log('handleSelectItem---11', record)
      this.$emit("handleSelectItem", record);
    },
    handleRelation(record) {
      if (!record) {
        return;
      }
      this.$emit('handleRelation', record);
    },
    handleRelationItem() {
      // 触发打开父子题关系设置弹窗事件
      if (!this.record) {
        return;
      }
      this.$emit('handleRelation', this.record);
    },
    handleColAdd(e, list) {
      this.$emit("handleColAdd", e, list);
    },
    handleColReplace(e, list) {
      let that = this;
      this.$emit("handleColReplace", e, list, function (cData) {
        that.record.parent = cData;
      });
    },
    handleChange(value, key) {
      this.$emit('change', value, key);
    },

    // 点击编辑
    labelEdit() {
      let that = this;

      if (this.editable) {
        return;
      }

      this.preSequence = this.record.sequence;
      this.preLabel = this.record.label;

      this.editable = true;
      this.$nextTick(() => {
        that.$refs.labelInput.focus();
      });
    },
    // 取消
    editCancel() {
      this.record.sequence = this.preSequence;
      this.record.label = this.preLabel;
      this.editable = false;
    },
    // 保存
    editSave() {
      this.editable = false;
    },

    // 离开焦点
    handleAllBlurred() {
      this.editSave();
    },
    refreshOptions() {
      this.$emit("refreshOptions");
    }
  }
};
</script>
<style scoped>
/deep/ .grid-box{
  background: none !important;
}
/deep/ .grid-row{
  background: none !important;
}
.drag-move.layout-width {
  margin: 0px -15px;
}
</style>